export default "__VITE_ASSET__DH7h$jIa__"